<script>
	import { onDestroy, getContext } from 'svelte'
	import { isAfter } from 'date-fns'
	import { styles } from '../../../library/scripts/styles.js'
	import { urlAdmin } from '../../../library/scripts/Setup.svelte'
	import { adminUpdateSeasonsEntry } from '../AdminModule.svelte'
	import DatePicker from '../../../library/LayoutStuff/DatePicker.svelte'
	import Shader from '../../../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../../../modals/Alert.svelte'

	const globals = getContext('globals')

	const shadow = globals.boxShadow
	const fontX = globals.fsL
	const fontM = globals.fsN
	const fontS = globals.fsS
	const color = globals.colorMain
	const inputFocus = globals.bgLight
	const buttonColor = globals.buttonColor
	const buttonHover = globals.buttonHover

	let seasonDates = {}
	let seasonName

	let seasons = null
	const adUpdSeasons = adminUpdateSeasonsEntry.subscribe((value) => {
		seasons = JSON.parse(value)
	})

	//success and error message
	let error = false
	let success = false

	//message to the user
	let message = ''

	//alert window
	let alertError = false

	const set_date = (e) => {
		if (seasonName) seasonDates.name = seasonName
		if (e.detail.cmd === 'start') {
			seasonDates = {
				name: seasonName,
				start: e.detail.value,
			}
		}
		if (e.detail.cmd === 'end') {
			seasonDates = { ...seasonDates, end: e.detail.value }
		}
	}

	const save_date = () => {
		if (!seasonName) {
			error = true
			message = 'please add season name'
			set_error()
			return
		}

		if (!seasonDates.start) {
			error = true
			message = 'please add season start-date'
			set_error()
			return
		}

		if (!seasonDates.end) {
			error = true
			message = 'please add seasos end-date'
			set_error()
			return
		}

		//compare dates
		const date1s = seasonDates.start.split('/')
		const date2s = seasonDates.end.split('/')

		const date1 = new Date(date1s[2] + ',' + date1s[1] + ',' + date1s[0])
		const date2 = new Date(date2s[2] + ',' + date2s[1] + ',' + date2s[0])

		if (isAfter(date1, date2)) {
			error = true
			message = 'start-date after end-date'
			set_error()
			return
		}

		const addedToDb = save_item_to_db(seasonDates)

		if (addedToDb) {
			seasons.push(seasonDates)
			adminUpdateSeasonsEntry.set(JSON.stringify(seasons))
			reset_dates()
		}
	}

	const reset_dates = () => {
		seasonDates = {}
		seasonName = null
	}

	const set_error = () => {
		const toError = setTimeout(() => {
			error = false
			message = ''
			clearTimeout(toError)
		}, 2000)
	}

	onDestroy(() => {
		adUpdSeasons
	})

	// ******************************** HELPER FUNCTIONS ***********************************//

	//safe entry to db
	const save_item_to_db = async (item) => {
		const saveItem = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'save_gh_seasons',
				dbtable: 'seasons',
				data: {
					name: item.name,
					start: item.start,
					end: item.end,
				},
			}),
		})

		const dataResponse = await saveItem.json()
		return dataResponse.response
	}

	//reset error messages
	const reset_error = () => {
		error = false
		success = false
		alertError = false
	}
</script>

<div class="container">
	<div class="title" use:styles={{ color, fontX }}>CREATE SEASON</div>
	<form use:styles={{ fontS }}>
		<div class="label" use:styles={{ fontM, color }} for="item">name</div>
		<input
			use:styles={{ fontM, color, shadow, inputFocus }}
			on:focus={reset_error}
			type="text"
			id="item"
			placeholder="season name"
			maxlength="25"
			bind:value={seasonName}
		/>
		<div class="label" use:styles={{ fontM, color }} for="size">start</div>
		<DatePicker
			cmd="start"
			backgroundColor="transparent"
			selectionDate={true}
			{color}
			colorDisabled="hsl(0,0%,50%)"
			on:getdate={set_date}
		/>

		<div class="label" use:styles={{ fontM, color }} for="size">end</div>
		<DatePicker
			cmd="end"
			backgroundColor="transparent"
			selectionDate={true}
			{color}
			colorDisabled="hsl(0,0%,50%)"
			on:getdate={set_date}
		/>

		<button use:styles={{ fontS, shadow, buttonColor, buttonHover }} on:click|preventDefault={save_date}>save</button>

		<!-- error and other messages -->
		{#if error}
			<div class="message error">{message}</div>
		{/if}
		{#if success}
			<div class="message success">{message}</div>
		{/if}
	</form>
</div>

{#if alertError}
	<Shader>
		<div slot="content">
			<Alert {message} showOkButton={false} alertMessage="ERROR" on:alertclose={reset_error} />
		</div>
	</Shader>
{/if}

<style>
	.container {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		width: 100%;
		cursor: default;
		user-select: none;
	}

	.title {
		font-size: var(--fontX);
		font-weight: bold;
		color: var(--color);
		margin: 30px 0 20px 20px;
	}

	form {
		display: grid;
		width: 80%;
		grid-template-columns: 20% 80%;
		margin-left: 3%;
		font-size: var(--fontS);
	}

	.label {
		display: flex;
		align-items: flex-start;
		font-size: var(--fontM);
		color: var(--color);
	}

	input[type='text'] {
		outline: none;
		box-shadow: 3px 3px 3px var(--shadow);
		font-size: var(--fontM);
		border: 1px solid ghostwhite;
		background-color: transparent;
		color: var(--color);
		width: 80%;
	}

	input[type='text']:focus {
		background-color: var(--inputFocus);
	}

	button {
		width: 20%;
		grid-column-start: 1;
		grid-column-end: 3;
		justify-self: flex-end;
		margin-right: 0%;
		border-radius: 5px;
		font-size: var(--fontS);
		color: var(--buttonColor);
		box-shadow: 3px 3px 3px var(--shadow);
		background-color: transparent;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonHover);
	}

	.message {
		grid-column-start: 1;
		grid-column-end: 3;
		justify-self: center;
		font-size: clamp(0.8rem, 1.1vw, 1.2rem);
	}

	.success {
		color: green;
	}

	.error {
		color: red;
	}
</style>
